'use strict';
define(['./TopNavDropdown', '../../../../lib/domQ', '../../data/config/app', './../Constant', './CountryLinks'], function (TopNavDropdown, domQ, config, constant, countryLinkDropDown) {

    var TOUCH_START = 'touchstart',
        BAGLABEL1 = 'Shopping bag with ',
        BAGLABEL2 = ' items',
        DEFAULT_L1ARIA = 'Sub menu. Button collapsed.',
        PREVENT_SCROLLING = 'navigation-prevent-scrolling';

    function DesktopDevice(level2, level3) {
        this.level2 = level2;
        this.level3 = level3;
        this.menuOverFlag = false;
        this.panelOverFlag = false;
        this.myaccountFlag = false;
        this.signInFlag = false;
        this.bodyEl = document.querySelector('body');
        this.closeButtonList = document.querySelectorAll('.nav-submenu__close-button');
        this.searchButtonReset = document.querySelector('.navigation-search-bar--clear');
        this.searchOverlayClose = document.querySelector('.navigation-dock-search-popup .navigation-search-bar--clear');
        this.searchiconButton = document.querySelector('.navigation-search-bar--submit');
        this.searchBarSuggession = document.querySelector('.navigation-search-bar--suggestion-dropdown');
        this.menuOver = this.menuOver.bind(this);
        this.menuAccKeyup = this.menuAccKeyup.bind(this);
        this.menuOut = this.menuOut.bind(this);
        this.panelOver = this.panelOver.bind(this);
        this.panelOut = this.panelOut.bind(this);
        this.setMenuTabindex = this.setMenuTabindex.bind(this);
        this.interactionEvent = 'click';
        this.myaccbutton = document.querySelector('.navigation-res-nav-header__item--myaccount');
        this.signInIcon = document.querySelector('.navigation-res-nav-header__item--login');
        this.signInChevron = document.querySelector('.navigation-accessibility__chevron');
        this.accountChevron = document.querySelector('.navigation-accessibility__chevron-account');
        this.countryLink = document.querySelector('.navigation-res-nav-header__icon--country');
        this.myaccountButton = document.querySelector('.navigation-header__sub-list-container--signacc');
        this.signInButton = document.querySelector('.navigation-header__signin');
        this.pageDiv = document.querySelector('.navigation-nav-veil');
        this.navSection = document.querySelector('.navigation-primary__section');
        this.signInDropdown = document.querySelector('.navigation-signin-wrapper');
        this.accountDropdown = document.querySelector('.navigation-signacc-wrapper');
        this.navPrimaryListEl = document.querySelectorAll('.nav-primary__list li');
        this.countrySelectorOverlay = document.querySelector('.navigation-country-selector--overlay');
        this.countrybackgroundOverlay = document.querySelector('.navigation-country-background--overlay');
        this.countrySelectorClose = document.querySelector('.navigation-country-overlay--close');
        this.bagElementUrl = document.querySelector('.navigation-res-nav-header__item--bag a');
        this.miniBagWithItemUrl = this.bagElementUrl.getAttribute('data-href');
        this.gotoCountryLink = document.querySelector('.navigation-country-overlay--link');
        this.firstNavLinkEl = (this.navPrimaryListEl[0] && this.navPrimaryListEl[0].classList.contains('.nav-primary-inspire-me')) ? this.navPrimaryListEl[1] : this.navPrimaryListEl[0];
        this.headerEl = document.getElementById('common-hdr-main');
        this.focusElement = document.querySelectorAll('.nav-primary__list a');
        this.signInElements = document.querySelectorAll('.navigation-header__sub-list.navigation-header__sub-list--signin');
        this.MyAccountElements = document.querySelectorAll('.navigation-header__sub-list.navigation-header__sub-list--my-account');
        this.countryOverlayExitSpan = document.querySelector('.navigation-country-overlay-exit');
        this.searchButtonResetClick = this.searchButtonResetClick.bind(this);
        this.closeCountryOverlayForDefault = this.closeCountryOverlayForDefault.bind(this);
        this.myaccountButtonClick = this.myaccountButtonClick.bind(this);
        this.myaccountButtonClickOut = this.myaccountButtonClickOut.bind(this);
        this.signInButtonClick = this.signInButtonClick.bind(this);
        this.signInButtonClickOut = this.signInButtonClickOut.bind(this);
        this.takeToNextLevel1 = this.takeToNextLevel1.bind(this);
        this.bagCountSet = this.bagCountSet.bind(this);
        this.countryLinkClick = this.countryLinkClick.bind(this);
        this.countryOverlayTransEnd = this.countryOverlayTransEnd.bind(this);
        this.countryLinkKeyUp = this.countryLinkKeyUp.bind(this);
        this.signInIconKeyUp = this.signInIconKeyUp.bind(this);
        this.myaccbuttonKeyUp = this.myaccbuttonKeyUp.bind(this);
        this.myEmptybagDisable = this.myEmptybagDisable.bind(this);
        this.focusToSubMenuElement = this.focusToSubMenuElement.bind(this);
        this.takeBacktoL1 = this.takeBacktoL1.bind(this);
        this.escapeToClose = this.escapeToClose.bind(this);
        this.tabCloseCountryOverlay = this.tabCloseCountryOverlay.bind(this);
        //Sign in dropdown links
        this.signInLinkClick = this.signInLinkClick.bind(this);
        this.createAccLinkClick = this.createAccLinkClick.bind(this);
        this.signInSparksLinkClick = this.signInSparksLinkClick.bind(this);
        //My account dropdown links
        this.yourOrdersLinkClick = this.yourOrdersLinkClick.bind(this);
        this.myAccSparksLinkClick = this.myAccSparksLinkClick.bind(this);
        this.cardsLinkClick = this.cardsLinkClick.bind(this);
        this.myAccLinkClick = this.myAccLinkClick.bind(this);
        this.signOutLinkClick = this.signOutLinkClick.bind(this);
        this.countrySelectorOverlayClose = this.countrySelectorOverlayClose.bind(this);
        this.countrySelectorOverlayCloseOnResize = this.countrySelectorOverlayCloseOnResize.bind(this);

        this.cardsLinkClickIE = this.cardsLinkClickIE.bind(this);
        this.myAccLinkClickIE = this.myAccLinkClickIE.bind(this);
        this.signOutLinkClickIE = this.signOutLinkClickIE.bind(this);
        this.searchOverlayCloseEvnt = this.searchOverlayCloseEvnt.bind(this);
    }
    DesktopDevice.prototype.searchButtonResetClick = function () {
        domQ(this.searchBarSuggession).addClass('navigation-search-bar--suggestion-dropdown__hidden');
        // domQ(this.searchiconButton).removeClass('navigation-search-bar--submit__active');
    };

    DesktopDevice.prototype.myaccountButtonClick = function () {
        var bagVar = document.querySelector('.navigation-minibag-dock-overlay.navigation-dock-overlay--block.navigation-dock-overlay--transition');
        if (bagVar) {
            domQ(bagVar).removeClass('navigation-dock-overlay--block');
            domQ(bagVar).removeClass('navigation-dock-overlay--transition');
        }
        if (!this.myaccountFlag) {
            this.myaccountFlag = true;
            domQ(this.accountDropdown).removeClass('navigation-signacc-wrapper-hidden');
            domQ(this.myaccountButton).addClass('navigation-header__sub-list-container--signacc-displayblock');
        } else {
            this.myaccountFlag = false;
            domQ(this.accountDropdown).addClass('navigation-signacc-wrapper-hidden');
            domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
        }
    };
    DesktopDevice.prototype.signInButtonClick = function () {
        var bagVar = document.querySelector('.navigation-minibag-dock-overlay.navigation-dock-overlay--block.navigation-dock-overlay--transition');
        if (bagVar) {
            domQ(bagVar).removeClass('navigation-dock-overlay--block');
            domQ(bagVar).removeClass('navigation-dock-overlay--transition');
        }
        if (!this.signInFlag) {
            this.signInFlag = true;
            domQ(this.signInDropdown).removeClass('navigation-signin-wrapper-hidden');
            domQ(this.signInButton).addClass('navigation-header__sign-in');
        } else {
            this.signInFlag = false;
            domQ(this.signInDropdown).addClass('navigation-signin-wrapper-hidden');
            domQ(this.signInButton).removeClass('navigation-header__sign-in');
        }
    };
    DesktopDevice.prototype.signInButtonClickOut = function () {
        this.signInFlag = false;
        if (!domQ(document.querySelector('.navigation-signin-wrapper')).hasClass('navigation-signin-wrapper-hidden')) {
            domQ(this.signInDropdown).addClass('navigation-signin-wrapper-hidden');
            domQ(this.signInButton).removeClass('navigation-header__sign-in');
        }
    };
    DesktopDevice.prototype.myaccountButtonClickOut = function () {
        this.myaccountFlag = false;
        domQ(this.accountDropdown).addClass('navigation-signacc-wrapper-hidden');
        domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
    };
    DesktopDevice.prototype.countryLinkClick = function () {
        countryLinkDropDown.buildDropDown();
        domQ(this.countrybackgroundOverlay).addClass('navigation-country-overlay-visible');
        domQ(this.countrySelectorOverlay).addClass('navigation-country-overlay-visible');
        domQ(this.myaccountButton).removeClass('navigation-header__sub-list-container--signacc-displayblock');
        domQ(this.pageDiv).removeClass('navigation-is-active-acc');
        domQ(this.navSection).removeClass('navigation-add-border');
        this.countrybackgroundOverlay.style.visibility = 'visible';
        this.countrySelectorOverlay.style.visibility = 'visible';
        domQ(this.bodyEl).addClass(PREVENT_SCROLLING);
        this.countrySelectorOverlay.focus();
    };
    DesktopDevice.prototype.closeCountryOverlayForDefault = function () {
        var countryDropdown = document.querySelector('.navigation-country-overlay--country-list');
        if (countryDropdown && countryDropdown.value === '0') {
            this.countrySelectorOverlayClose();
        }
    };

    DesktopDevice.prototype.countrySelectorOverlayCloseOnResize = function () {
        domQ(this.bodyEl).removeClass(PREVENT_SCROLLING);
        domQ(this.countrybackgroundOverlay).removeClass('navigation-country-overlay-visible');
        domQ(this.countrySelectorOverlay).removeClass('navigation-country-overlay-visible');
        if (!domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
            this.countrybackgroundOverlay.style.visibility = 'hidden';
            this.countrySelectorOverlay.style.visibility = 'hidden';
            countryLinkDropDown.resetDropDown();
        }
    };
    DesktopDevice.prototype.countrySelectorOverlayClose = function () {
        domQ(this.bodyEl).removeClass(PREVENT_SCROLLING);
        domQ(this.countrybackgroundOverlay).removeClass('navigation-country-overlay-visible');
        domQ(this.countrySelectorOverlay).removeClass('navigation-country-overlay-visible');
    };
    DesktopDevice.prototype.countryOverlayTransEnd = function () {
        if (!domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
            this.countrybackgroundOverlay.style.visibility = 'hidden';
            this.countrySelectorOverlay.style.visibility = 'hidden';
            countryLinkDropDown.resetDropDown();
        }
    };
    DesktopDevice.prototype.countryLinkKeyUp = function (event) {
        var keyPressed = event.key || event.keyCode;
        if (keyPressed === 13 || keyPressed === 'Enter' || keyPressed === 32 || keyPressed === ' ') {
            this.countryLinkClick();
            this.countrySelectorOverlay.focus();
        }
        else if (domQ(this.countrySelectorOverlay).hasClass('navigation-country-overlay-visible')) {
            this.countrySelectorOverlayClose();
            this.countryLink.focus();
        }
    };
    DesktopDevice.prototype.tabCloseCountryOverlay = function (event) {
        var keyPressed = event.key || event.keyCode;
        if ((domQ(event.target).hasClass('navigation-country-overlay--link') || domQ(event.target).hasClass('navigation-country-overlay--close')) && (keyPressed === 13 || keyPressed === 'Enter')) {
            this.countrySelectorOverlayClose();
            this.countryLink.focus();
        } else if (domQ(event.target).hasClass('navigation-country-overlay-exit') && (keyPressed === 'Tab' || keyPressed === 9)) {
            this.countrySelectorOverlayClose();
            this.countryLink.focus();
        } else if (keyPressed === 27 || keyPressed === 'Escape') {
            this.countrySelectorOverlayClose();
            this.countryLink.focus();
        }
    };
    DesktopDevice.prototype.bind = function () {
        var _this = this;
        this.searchButtonReset.addEventListener(this.interactionEvent, this.searchButtonResetClick);
        this.myaccbutton.addEventListener('mouseover', this.myaccountButtonClick);
        this.myaccbutton.addEventListener('mouseout', this.myaccountButtonClickOut);
        this.signInIcon.addEventListener('mouseover', this.signInButtonClick);
        this.signInIcon.addEventListener('mouseout', this.signInButtonClickOut);
        this.pageDiv.addEventListener('touchstart', this.level2.checkClickToClose);
        this.searchOverlayClose.addEventListener('keyup', this.searchOverlayCloseEvnt);
        this.gotoCountryLink.addEventListener('click', this.closeCountryOverlayForDefault);

        this.countryLink.addEventListener(this.interactionEvent, this.countryLinkClick);
        this.gotoCountryLink.addEventListener('blur', this.closeCountryOverlayForDefault);
        this.countrySelectorOverlay.addEventListener('keyup', this.tabCloseCountryOverlay);
        this.countrybackgroundOverlay.addEventListener(this.interactionEvent, this.countrySelectorOverlayClose);
        this.countrySelectorClose.addEventListener(this.interactionEvent, this.countrySelectorOverlayClose);
        this.countrySelectorClose.addEventListener('keyup', this.tabCloseCountryOverlay);
        this.countryOverlayExitSpan.addEventListener('keyup', this.tabCloseCountryOverlay);

        this.countrySelectorOverlay.addEventListener('transitionend', this.countryOverlayTransEnd);
        this.countrySelectorOverlay.addEventListener('webkitTransitionEnd', this.countryOverlayTransEnd);
        this.countrySelectorOverlay.addEventListener('mozTransitionEnd', this.countryOverlayTransEnd);
        this.countrySelectorOverlay.addEventListener('oTransitionEnd', this.countryOverlayTransEnd);
        function signInIconEvent() {
            if (_this.signInFlag) {
                _this.signInButtonClickOut();
                _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
            }
        }

        function signInIconKeyUpEvent() {
            var signInIcon = document.querySelector('.navigation-res-nav-header__login-link');
            signInIcon.addEventListener('keyup', signInIconEvent);
        }

        function miniBagEvent() {
            if (_this.signInFlag) {
                _this.signInButtonClickOut();
                _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
            }
            else if (_this.myaccountFlag) {
                _this.myaccountButtonClickOut();
                _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
            }
        }
        var cheveronlist = document.querySelectorAll('.navigation-l1-chervonicon');
        for (var chevi = 0; chevi < cheveronlist.length; chevi++) {
            cheveronlist[chevi].setAttribute('aria-expanded', 'false');
        }

        function signInContainerEvent(event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 27 || keyPressed === 'Escape') {
                if (_this.signInFlag) {
                    _this.signInButtonClickOut();
                    _this.signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
                    _this.signInChevron.focus();
                }
            }
        }

        function siginInChevronEvent(event) {
            event.preventDefault();
            _this.signInButtonClick();
            event.stopPropagation();
            var signInChevron = document.querySelector('.navigation-accessibility__chevron');
            if (!domQ(document.querySelector('.navigation-signin-wrapper')).hasClass('navigation-signin-wrapper-hidden')) {
                signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button expanded');
                signInChevron.blur();
                signInChevron.focus();
            } else {
                signInChevron.setAttribute('aria-label', 'Sign in or Register sub-menu. Button collapsed');
                signInChevron.blur();
                signInChevron.focus();
            }
            signInIconKeyUpEvent();

            var miniBagLink = document.querySelector('.navigation-header__link');
            miniBagLink.addEventListener('keyup', miniBagEvent);

            var signInContainer = document.querySelector('.navigation-dropdown__list-container-signin');
            signInContainer.addEventListener('keyup', signInContainerEvent);
        }


        function accountIconEvent() {
            if (_this.myaccountFlag) {
                _this.myaccountButtonClickOut();
                _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
            }
        }

        function accountIconKeyUpEvent() {
            var myaccountIcon = document.querySelector('.navigation-res-nav-header__icon--my-account');
            myaccountIcon.addEventListener('keyup', accountIconEvent);
        }

        function accountContainerEvent(event) {
            var keyPressed = event.key || event.keyCode;
            if (keyPressed === 27 || keyPressed === 'Escape') {
                if (_this.myaccountFlag) {
                    _this.myaccountButtonClickOut();
                    _this.accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
                    _this.accountChevron.focus();
                }
            }
        }

        function accountChevronEvent(event) {

            event.preventDefault();
            _this.myaccountButtonClick();
            event.stopPropagation();
            var accountChevron = document.querySelector('.navigation-accessibility__chevron-account');
            if (!domQ(document.querySelector('.navigation-signacc-wrapper')).hasClass('navigation-signacc-wrapper-hidden')) {
                accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button expanded');
                accountChevron.blur();
                accountChevron.focus();
            } else {
                accountChevron.setAttribute('aria-label', 'My Account sub-menu. Button collapsed');
                accountChevron.blur();
                accountChevron.focus();
            }
            accountIconKeyUpEvent();

            var miniBagLink = document.querySelector('.navigation-header__link');
            miniBagLink.addEventListener('keyup', miniBagEvent);

            var myAccountContainer = document.querySelector('.navigation-dropdown__list-container-myaccount');
            myAccountContainer.addEventListener('keyup', accountContainerEvent);
        }

        this.accountChevron.addEventListener('click', accountChevronEvent);

        this.signInChevron.addEventListener('click', siginInChevronEvent);
        this.bagElementUrl.addEventListener('keyup', this.myEmptybagDisable);

        for (var iListItem = 0; iListItem < this.level2.navPrimaryAList.length; iListItem++) {
            var aListEl = _this.level2.navPrimaryAList[iListItem];
            aListEl.addEventListener('mouseover', _this.menuOver);
            aListEl.addEventListener('mouseout', _this.menuOut);
            aListEl.addEventListener('keyup', _this.menuOut);
            aListEl.removeAttribute('aria-expanded');
            if (aListEl.nextElementSibling) {
                var lbl = aListEl.nextElementSibling.getAttribute('aria-label');
                if (lbl === DEFAULT_L1ARIA) {
                    var elCont = aListEl.innerText + ' ' + lbl;
                    aListEl.nextElementSibling.setAttribute('aria-label', elCont);
                }
                aListEl.nextElementSibling.addEventListener('keyup', _this.menuAccKeyup);
            }
        }

        for (var iSubMenuItem = 0; iSubMenuItem < this.level3.navPrimarySubmenuList.length; iSubMenuItem++) {
            var el = _this.level3.navPrimarySubmenuList[iSubMenuItem];
            el.addEventListener('mouseover', _this.panelOver);
            el.addEventListener('mouseout', _this.panelOut);
        }

        for (var closeButtons = 0, len = _this.closeButtonList.length; closeButtons < len; closeButtons++) {
            _this.closeButtonList[closeButtons].addEventListener('click', _this.level2.checkClickToClose);
        }

        _this.bagCountSet();
        var navLinkList = document.querySelectorAll('.navigation-primary__section>ul>li>a');
        for (var navLink = 0; navLink < navLinkList.length; navLink++) {
            navLinkList[navLink].tabIndex = '0';
            navLinkList[navLink].removeAttribute('aria-expanded');
        }
        if (this.signInElements) {
            this.signInElements[0].addEventListener(TOUCH_START, this.signInLinkClick);
            this.signInElements[1].addEventListener(TOUCH_START, this.createAccLinkClick);
            if (config && config.storeId === constant.ukId) {
                this.signInElements[2].addEventListener(TOUCH_START, this.signInSparksLinkClick);
            }
        }
        if (this.MyAccountElements) {
            this.MyAccountElements[0].addEventListener(TOUCH_START, this.yourOrdersLinkClick);
            if (config && config.storeId === constant.ukId) {
                this.MyAccountElements[1].addEventListener(TOUCH_START, this.myAccSparksLinkClick);
                this.MyAccountElements[2].addEventListener(TOUCH_START, this.cardsLinkClick);
                this.MyAccountElements[3].addEventListener(TOUCH_START, this.myAccLinkClick);
                this.MyAccountElements[4].addEventListener(TOUCH_START, this.signOutLinkClick);
            } else if (config && config.storeId === constant.ieId) {
                this.MyAccountElements[1].addEventListener(TOUCH_START, this.cardsLinkClickIE);
                this.MyAccountElements[2].addEventListener(TOUCH_START, this.myAccLinkClickIE);
                this.MyAccountElements[3].addEventListener(TOUCH_START, this.signOutLinkClickIE);
            }
        }
    };
    DesktopDevice.prototype.signInLinkClick = function () {
        window.location = this.signInElements[0] ? this.signInElements[0].firstElementChild.href : '';
    };
    DesktopDevice.prototype.createAccLinkClick = function () {
        window.location = this.signInElements[1] ? this.signInElements[1].firstElementChild.href : '';
    };
    DesktopDevice.prototype.signInSparksLinkClick = function () {
        window.location = this.signInElements[2] ? this.signInElements[2].firstElementChild.href : '';
    };
    DesktopDevice.prototype.yourOrdersLinkClick = function () {
        window.location = this.MyAccountElements[0] ? this.MyAccountElements[0].firstElementChild.href : '';
    };
    DesktopDevice.prototype.myAccSparksLinkClick = function () {
        window.location = this.MyAccountElements[1] ? this.MyAccountElements[1].firstElementChild.href : '';
    };
    DesktopDevice.prototype.cardsLinkClick = function () {
        window.location = this.MyAccountElements[2] ? this.MyAccountElements[2].firstElementChild.href : '';
    };
    DesktopDevice.prototype.myAccLinkClick = function () {
        window.location = this.MyAccountElements[3] ? this.MyAccountElements[3].firstElementChild.href : '';
    };
    DesktopDevice.prototype.signOutLinkClick = function () {
        window.location = this.MyAccountElements[4] ? this.MyAccountElements[4].firstElementChild.href : '';
    };
    DesktopDevice.prototype.cardsLinkClickIE = function () {
        window.location = this.MyAccountElements[1] ? this.MyAccountElements[1].firstElementChild.href : '';
    };
    DesktopDevice.prototype.myAccLinkClickIE = function () {
        window.location = this.MyAccountElements[2] ? this.MyAccountElements[2].firstElementChild.href : '';
    };
    DesktopDevice.prototype.signOutLinkClickIE = function () {
        window.location = this.MyAccountElements[3] ? this.MyAccountElements[3].firstElementChild.href : '';
    };
    DesktopDevice.prototype.unbind = function () {
        var _this = this;
        this.myaccbutton.removeEventListener('mouseover', this.myaccountButtonClick);
        this.myaccbutton.removeEventListener('mouseout', this.myaccountButtonClickOut);
        this.signInIcon.removeEventListener('mouseover', this.signInButtonClick);
        this.signInIcon.removeEventListener('mouseout', this.signInButtonClickOut);

        for (var iListItem = 0; iListItem < this.level2.navPrimaryAList.length; iListItem++) {
            var aListEl = _this.level2.navPrimaryAList[iListItem];
            aListEl.removeEventListener('mouseover', _this.menuOver);
            aListEl.removeEventListener('mouseout', _this.menuOut);
            aListEl.removeEventListener('keyup', _this.menuOut);
        }

        for (var iSubMenuItem = 0; iSubMenuItem < this.level3.navPrimarySubmenuList.length; iSubMenuItem++) {
            var el = _this.level3.navPrimarySubmenuList[iSubMenuItem];
            el.removeEventListener('mouseover', _this.panelOver);
            el.removeEventListener('mouseout', _this.panelOut);
        }

        for (var closeButtons = 0, len = _this.closeButtonList.length; closeButtons < len; closeButtons++) {
            _this.closeButtonList[closeButtons].removeEventListener('click', _this.level2.checkClickToClose);
        }

        clearTimeout(this.timeoutId);
    };
    DesktopDevice.prototype.menuOver = function (e) {
        this.menuOverFlag = true;
        var _this = this;
        function timeoutFunc() {
            if (_this.menuOverFlag) {
                _this.level2.activate(e.target);
            }
        }
        this.timeoutId = setTimeout(timeoutFunc, 100);
        TopNavDropdown.close();
    };

    DesktopDevice.prototype.menuOut = function () {
        this.menuOverFlag = false;
        this.deactivate();
        var tempSpan = document.getElementById('navigation-temp-span');
        if (tempSpan) {
            tempSpan.parentElement.removeChild(tempSpan);
        }
    };
    DesktopDevice.prototype.panelOver = function () {
        this.panelOverFlag = true;
    };
    DesktopDevice.prototype.panelOut = function () {
        this.panelOverFlag = false;
        this.deactivate();
    };
    DesktopDevice.prototype.deactivate = function () {
        var _this = this;
        function timeoutFunc() {
            if (!_this.menuOverFlag && !_this.panelOverFlag) {
                _this.level2.deactivate();
            }
        }
        this.timeoutId = setTimeout(timeoutFunc, 100);
    };

    DesktopDevice.prototype.menuAccKeyup = function (event) {
        var keyPressed = event.key || event.keyCode;
        var areaLbl = event.target.getAttribute('aria-label');
        var _this = this;
        areaLbl = areaLbl.replace('expanded', 'collapsed');
        event.target.setAttribute('aria-label', areaLbl);
        if (keyPressed === 13 || keyPressed === 'Enter' || keyPressed === ' ' || keyPressed === 32) {
            var openMenu = document.querySelector('.navigation-open-submenu');
            var tempSpan2 = document.getElementById('navigation-temp-span');
            if (openMenu && tempSpan2) {
                tempSpan2.parentElement.removeChild(tempSpan2);
            }
            if (openMenu) {
                _this.level2.deactivate();
                areaLbl = event.target.getAttribute('aria-label');
                areaLbl = areaLbl.replace('expanded', 'collapsed');
                event.target.setAttribute('aria-label', areaLbl);
            } else {
                _this.menuOverFlag = true;
                _this.level2.activate(event.target.previousElementSibling);
                if (!event.target.nextElementSibling) {
                    var tempSpan = document.createElement('SPAN');
                    var element = event.target.parentElement;
                    tempSpan.tabIndex = '0';
                    tempSpan.id = 'navigation-temp-span';
                    element.appendChild(tempSpan);
                    tempSpan.addEventListener('keyup', _this.focusToSubMenuElement);
                }
                areaLbl = event.target.getAttribute('aria-label');
                areaLbl = areaLbl.replace('collapsed', 'expanded');
                event.target.setAttribute('aria-label', areaLbl);
                event.target.blur();
                event.target.focus();
                TopNavDropdown.close();
            }
        }
    };

    DesktopDevice.prototype.focusToSubMenuElement = function (event) {
        var backLink = document.querySelector('.navigation-back-accessibility');
        backLink.tabIndex = '0';
        backLink.addEventListener('keyup', this.takeBacktoL1);
        var openMenu = document.querySelector('.navigation-open-submenu');
        openMenu.addEventListener('keyup', this.escapeToClose);
        var clickableList = openMenu.querySelectorAll('.nav-submenu__l2-header, .copy div, .nav-submenu__style-and-living div:first-child, a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        this.setMenuTabindex(clickableList, 0);
        clickableList[0].focus();
        var tempHolder = document.querySelector('.navigation-temp-accessibility');
        tempHolder.style.display = 'block';
        tempHolder.addEventListener('keyup', this.takeToNextLevel1);
        var tempSpan = event.target;
        tempSpan.parentNode.removeChild(tempSpan);
    };

    DesktopDevice.prototype.takeBacktoL1 = function () {
        var activeItem = document.querySelector('.nav-primary__menu-link.navigation-is-active');
        if (activeItem && activeItem.nextElementSibling) {
            this.menuOverFlag = false;
            activeItem.nextElementSibling.focus();
            this.level2.deactivate();
            var backLink = document.querySelector('.navigation-back-accessibility');
            backLink.tabIndex = '-1';
            var tempHolder = document.querySelector('.navigation-temp-accessibility');
            tempHolder.style.display = 'none';
            var areaLbl = activeItem.nextElementSibling.getAttribute('aria-label');
            areaLbl = areaLbl.replace('expanded', 'collapsed');
            activeItem.nextElementSibling.setAttribute('aria-label', areaLbl);
        }
    };

    DesktopDevice.prototype.escapeToClose = function (event) {
        var keyPressed = event.key || event.keyCode;
        if (keyPressed === 27 || keyPressed === 'Esc' || keyPressed === 'Escape') {
            this.takeBacktoL1();
        }
    };

    DesktopDevice.prototype.takeToNextLevel1 = function () {
        var backLink = document.querySelector('.navigation-back-accessibility');
        backLink.tabIndex = '-1';
        var currentLi = document.querySelector('li.navigation-is-active');
        var nextElement = currentLi.nextElementSibling;
        var initialContentLink = null;
        var pageContent = this.headerEl ? this.headerEl.nextElementSibling:false;
        if (pageContent) {
            initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            while (pageContent && pageContent !== null && !initialContentLink) {
                pageContent = pageContent.nextElementSibling;
                if (pageContent) {
                    initialContentLink = pageContent.querySelector('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                }
            }
        }
        if (nextElement && nextElement.classList.contains('nav-primary-inspire-me')) {
            nextElement = nextElement.nextElementSibling ? nextElement.nextElementSibling : null;
        }
        var focusEl = nextElement ? nextElement.firstElementChild : initialContentLink;
        this.menuOverFlag = false;
        this.level2.deactivate();
        var tempHolder = document.querySelector('.navigation-temp-accessibility');
        tempHolder.style.display = 'none';
        tempHolder.removeEventListener('keyup', this.takeToNextLevel1);
        if (focusEl) {
            focusEl.focus();
        }
    };

    DesktopDevice.prototype.setMenuTabindex = function (elList, tabValue) {
        for (var i = 0; i < elList.length; i++) {
            elList[i].tabIndex = tabValue;
        }
    };

    DesktopDevice.prototype.bagCountSet = function () {
        //Aria-Label for bag
        var bag = document.querySelector('.navigation-res-nav-header__item--bag a');
        var count = document.querySelector('.navigation-res-nav-header__item--bag .navigation-nav-header__bag-count').innerText;
        bag.setAttribute('aria-label', BAGLABEL1 + count + BAGLABEL2);
    };

    DesktopDevice.prototype.searchOverlayCloseEvnt = function (event) {
        var keyPressed = event.key;
        if (keyPressed === 'Enter') {
            var dummySearch = document.querySelector('.navigation-dropdown__panel--search');
            dummySearch.focus();
        }
    };

    DesktopDevice.prototype.signInIconKeyUp = function (event) {
        var keyPressed = event.key || event.keyCode;
        if (keyPressed === 40 || keyPressed === 'ArrowDown') {
            event.preventDefault();
            this.signInFlag = false;
            this.signInButtonClick();
            event.stopPropagation();
        } else if (keyPressed === 38 || keyPressed === 'ArrowUp') {
            this.signInFlag = false;
            this.signInButtonClickOut();
            event.stopPropagation();
        }
    };
    DesktopDevice.prototype.myaccbuttonKeyUp = function (event) {
        var keyPressed = event.key || event.keyCode;
        if (keyPressed === 40 || keyPressed === 'ArrowDown') {
            event.preventDefault();
            this.myaccountFlag = false;
            this.myaccountButtonClick();
            event.stopPropagation();
        } else if (keyPressed === 38 || keyPressed === 'ArrowUp') {
            this.myaccountFlag = false;
            this.myaccountButtonClickOut();
            event.stopPropagation();
        }
    };

    //Accessibility disabling empty bag Enter

    DesktopDevice.prototype.myEmptybagDisable = function () {
        if (document.querySelector('.navigation-nav-header__bag-count').innerText === '0') {
            this.bagElementUrl.setAttribute('href', 'javascript:void(0)');
        }
        else {
            this.bagElementUrl.setAttribute('href', this.miniBagWithItemUrl);
        }
    };

    //Page reload on Safari  on back button click
    var userAgent = window.navigator.userAgent;
    var isSafari = userAgent.indexOf('Safari');
    var isChrome = userAgent.indexOf('Chrome');
    if (isSafari !== -1 && isChrome === -1) {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }

    return DesktopDevice;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/DesktopDevice.js